<template>
  <div class="info-page">
    <crumbs title="机器人企业填报" />
    <el-form
      :model="form"
      :rules="rules"
      ref="ruleForm"
      label-position="right"
      label-width="auto"
    >
      <div class="info-page__item">
        <div class="info-page__title">
          <span>详细信息</span>
        </div>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="企业名称" prop="companyName">
              <el-input
                v-model="form.companyName"
                placeholder="请输入企业名称"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="所属地区" prop="regionAddress">
              <region
                v-model="form.regionAddress"
                placeholder="请选择所属地区"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="办公地址" prop="companyAdress">
              <el-input
                v-model="form.companyAdress"
                placeholder="请输入办公地址"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="企业规模" prop="companyScale">
              <el-input
                v-model="form.companyScale"
                placeholder="请输入企业规模描述，如收入、订单等"
                maxlength="500"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              label="企业需求"
              prop="companyRequire"
              class="no-label"
            >
              <el-input
                v-model="form.companyRequire"
                type="textarea"
                :autosize="{ minRows: 3 }"
                placeholder="请输入企业需求"
                maxlength="2000"
                show-word-limit
                resize="none"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="info-page__item">
        <div class="info-page__title">
          <span>上游零部件加工企业合作情况</span>
        </div>
        <div v-for="(item, index) in form.teamWorkList" :key="index">
          <el-row :gutter="0">
            <el-col :span="12">
              <el-form-item
                label="企业名称"
                :prop="'teamWorkList.' + index + '.name'"
                :rules="isEmpty('请输入企业名称')"
              >
                <el-input
                  v-model="item.name"
                  placeholder="请输入企业名称"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="企业办公地址"
                :prop="'teamWorkList.' + index + '.adress'"
                :rules="isEmpty('请输入企业办公地址')"
              >
                <el-input
                  v-model="item.adress"
                  placeholder="请输入企业办公地址"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="0">
            <el-col :span="12">
              <el-form-item
                label="加工零部件种类"
                :prop="'teamWorkList.' + index + '.category'"
                :rules="isEmpty('请输入加工零部件种类')"
              >
                <el-input
                  v-model="item.category"
                  placeholder="请输入加工零部件种类"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="加工精度"
                :prop="'teamWorkList.' + index + '.processAccuracy'"
                :rules="isEmpty('请输入加工精度')"
              >
                <el-input
                  v-model="item.processAccuracy"
                  placeholder="请输入加工精度"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="0">
            <el-col :span="12">
              <el-form-item
                label="加工周期"
                :prop="'teamWorkList.' + index + '.processCycle'"
                :rules="isEmpty('请输入加工周期')"
              >
                <el-input
                  v-model="item.processCycle"
                  placeholder="请输入加工周期"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="年度加工订单量"
                :prop="'teamWorkList.' + index + '.orderCount'"
                :rules="isEmpty('请输入年度加工订单量')"
              >
                <el-input
                  v-model="item.orderCount"
                  placeholder="请输入年度加工订单量"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="0">
            <el-col :span="24">
              <el-form-item
                label="其他"
                :prop="'teamWorkList.' + index + '.other'"
                :rules="isEmpty('请输入其他')"
              >
                <el-input
                  v-model="item.other"
                  placeholder="请输入其他"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="0">
            <el-col :span="24">
              <el-form-item label="">
                <template
                  v-if="
                    form.teamWorkList.length < 5 &&
                    index === form.teamWorkList.length - 1
                  "
                >
                  <el-button
                    type="primary"
                    icon="el-icon-plus"
                    @click.prevent="addTeamWork"
                    >继续添加</el-button
                  >
                </template>
                <template v-else>
                  <el-button
                    type="warning"
                    icon="el-icon-minus"
                    @click.prevent="removeTeamWork(index)"
                    >删除</el-button
                  >
                </template>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="info-page__item">
        <div class="info-page__title">
          <span>联系人</span>
        </div>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="姓名" prop="contactName">
              <el-input
                v-model="form.contactName"
                placeholder="请输入姓名"
                maxlength="15"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="职务" prop="contactPosition">
              <el-input
                v-model="form.contactPosition"
                placeholder="请输入职务"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="联系方式" prop="contactContactWay">
              <el-input
                v-model="form.contactContactWay"
                placeholder="请填写手机或固定座机 如：010-87654321"
                maxlength="13"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱" prop="contactEmail">
              <el-input
                v-model="form.contactEmail"
                placeholder="请输入邮箱"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <div class="submit fn-text-center mt-20">
      <template v-if="isAdd">
        <el-button
          type="primary"
          :loading="isLoading"
          plain
          @click="handlerAddData('ruleForm')"
          >提交</el-button
        >
      </template>
      <template v-else>
        <el-button
          type="primary"
          :loading="isLoading"
          plain
          @click="handlerModifyData('ruleForm')"
          >提交</el-button
        >
      </template>
    </div>
  </div>
</template>

<script>
import CheckObj from "@/utils/check.js";
export default {
  name: "machiningRobotInfo",
  data() {
    const isEmpty = (
      message = "该项值不能为空",
      trigger = ["blur", "change"]
    ) => {
      return {
        required: true,
        message,
        trigger
      };
    };
    return {
      isEmpty,
      // 是否处于loading状态
      isLoading: false,
      //是添加数据还是修改数据
      isAdd: true,
      //表单
      form: {
        companyName: "",
        regionAddress: [],
        companyAdress: "",
        companyScale: "",
        companyRequire: "",
        // 企业合作情况
        teamWorkList: [
          {
            name: "",
            adress: "",
            processAccuracy: "",
            processCycle: "",
            category: "",
            other: "",
            orderCount: ""
          }
        ],
        // 联系人
        contactName: "",
        contactPosition: "",
        contactContactWay: "",
        contactEmail: ""
      },
      rules: {
        companyName: [isEmpty("请输入企业名称")],
        regionAddress: [isEmpty("请选择所属地区", "change")],
        companyAdress: [isEmpty("请输入办公地址")],
        companyScale: [isEmpty("请输入企业规模")],
        companyRequire: [isEmpty("请输入企业需求")],
        contactName: [
          isEmpty("请输入姓名"),
          {
            validator: (rule, value, callback) => {
              if (value && !CheckObj.checkChineseName(value)) {
                return callback(new Error("请输入正确的中文姓名"));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        contactPosition: [isEmpty("请输入职务")],
        contactContactWay: [
          isEmpty("请输入联系方式"),
          {
            validator: (rule, value, callback) => {
              if (
                value &&
                !CheckObj.checkPhone(value) &&
                !CheckObj.checkTelephone(value)
              ) {
                return callback(new Error("请输入正确的电话号码"));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        contactEmail: [
          {
            validator: (rule, value, callback) => {
              if (value && !CheckObj.checkEmail(value)) {
                return callback(new Error("请输入正确的邮箱"));
              }
              callback();
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    const { method } = this.$route.params;
    // 默认值 走添加流程
    let isAdd = true;
    if (method === "modification") {
      //获取信息
      this.loadInfo();
      //走修改流程
      isAdd = false;
    }
    this.isAdd = isAdd;
  },
  methods: {
    // 添加删除
    addTeamWork() {
      // if (this.form.teamWorkList.length > 4) return;
      this.form.teamWorkList.push({
        name: "",
        adress: "",
        processAccuracy: "",
        processCycle: "",
        category: "",
        other: "",
        orderCount: ""
      });
    },
    removeTeamWork(index) {
      this.form.teamWorkList.splice(index, 1);
    },
    // 正向处理数据 将数据处理后提交
    processDataSubmit() {
      const {
        // list
        regionAddress,
        ...others
      } = this.form;
      // 处理 regionAddress
      const [provinceCode = "", cityCode = "", districtCode = ""] =
        regionAddress;
      return {
        ...others,
        provinceCode,
        cityCode,
        districtCode
      };
    },
    // 逆向处理数据 获取后进行数据处理回显
    downloadProcessData(data) {
      const {
        provinceCode = "",
        cityCode = "",
        districtCode = "",
        ...others
      } = data;
      return {
        ...others,
        regionAddress: [provinceCode, cityCode, districtCode]
      };
    },
    // 点击添加数据按钮
    handlerAddData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadAddData();
        }
      });
    },
    // 点击修改数据按钮
    handlerModifyData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadModifyData();
        }
      });
    },
    // 加载添加数据接口
    loadAddData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      this.$api("machining", "addRobot", params).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },
    // 加载修改数据接口
    loadModifyData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      const { id } = this.$route.query;
      this.$api("machining", "addRobot", {
        ...params,
        id
      }).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },
    // 加载数据接口
    loadInfo() {
      const { id } = this.$route.query;
      this.$api("machining", "getRobotInfo", { id }).then((res) => {
        const { code, message } = res;
        if (code === 0) {
          this.form = this.downloadProcessData(res.dataList);
        } else {
          this.$message.error(message);
          this.redirectTo();
        }
      });
    },
    // 返回列表页
    redirectTo() {
      // this.redirectByPath(`/admin/policyManage/projectMessageList`);
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped></style>
